import { i18nMark } from 'lingui-react';

const messages = {
  assets: i18nMark('Assets'),
  cases: i18nMark('Cases'),
  in: i18nMark('in'),
};

export default messages;



// WEBPACK FOOTER //
// ./elements/Autosuggest/messages.js